<template>
    <v-col cols="12">
        <v-card v-for="item in lists" class="my-3 overflow-visible ms-1 helpical-cards">
            <v-row justify="space-between" class="pa-2" dense align="center">
                <v-col cols="auto" class="rounded ms-n7" :style="{backgroundColor: item.color ?? '#2877dc',boxShadow: `-2px 2px 10px ${item.color ?? '#2877dc'}75`}">
                    <v-icon class="pa-5" color="white" size="27">{{icon}}</v-icon>
                </v-col>
                <v-col>
                    <p class="text-meta text-grey-darken-2 font-weight-medium ms-4">{{item[labelKey]}}</p>
                </v-col>
                <v-col cols="auto">
                    <v-btn color="secondary" variant="text" icon="icon-editt" @click="editCard(item.id)" v-if="showActions.editable"></v-btn>
                    <v-btn color="error" variant="text" icon="icon-trash" @click="deleteCard(item.id,item[labelKey])" v-if="showActions.deletable"></v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-col>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: "person",
        },
        lists: {
            type: Array,
            default: [],
        },
        showDetails: {
            type: Boolean,
            default: true,
        },
        reRender: {
            type: Boolean,
            default: false,
        },
        showActions: {
            type: Object,
            default() {
                return { editable: true, deletable: true };
            },
        },
        labelKey: {
            type: String,
            default: 'name'
        }
    },
    methods: {
        editCard(id) {
            this.$emit("editCard", id);
        },
        deleteCard(id,name) {
            this.$confirm(`<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، گزینه <b>${name}</b> حذف خواهد شد.</p>`,
                { buttonTrueText: "حذف", buttonTrueColor: "error" }
            ).then(res=>{
                if(res)
                    this.$emit("deleteCard", id);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.box-shadow-card {
    box-shadow: 0px 0px 15px #0000001c;
}
.workingShiftCard-overlay {
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
    width: 54px;
    height: 54px;
}
.workingShift-edit-icon {
    transition: all 0.4s;
    padding: 4px;
    border-radius: 4px;
    &:hover {
        background-color: rgba(65, 145, 192, 0.233);
    }
    &::after {
        display: none !important;
    }
}
.workingShift-delete-icon {
    transition: all 0.4s;
    padding: 4px;
    border-radius: 4px;
    &:hover {
        background-color: rgba(204, 50, 50, 0.233);
    }
    &::after {
        display: none !important;
    }
}
</style>
